import { View } from 'react-native'
import cn from '@ui/utils/cn'
import Typography from '@ui/typography'
import { leadingNone } from '@ui/typography/styles'
import { colors } from '@ui/colors'
import { InputLabelProps as Props } from './types'
import { useAnimatedInputLabelTop } from './useAnimatedInputBorder'

export default function InputLabelTop(props: Props) {
  const { label, required, success, error, focus, disabled, readonly } = props

  const styleText = useAnimatedInputLabelTop({
    focus,
    error,
    success,
    disabled,
    readonly,
  })

  return (
    <View className="relative inset-0 flex flex-row items-center justify-start gap-1 px-6 py-1">
      <Typography
        variant="SMB"
        className={cn('font-text-semibold tracking-normal', leadingNone)}
        style={styleText}
      >
        {label}
      </Typography>
      {required && (
        <Typography
          variant="SMB"
          className="h-1 w-1 rounded-full"
          style={{ color: colors.orange[600], top: -7 }}
        >
          *
        </Typography>
      )}
    </View>
  )
}
